import * as PLAYBACKS from '../constants/routes/playbacks';

const URL_REGEXP = /\/(?<hasSites>sites)\/\d+\/playbacks(?:\/list)?/i;
/*
    ⚠️ This function is strictly related to playbacks list. ⚠️

    It returns the list's route names.
*/
export const getRouteListNameFromUrl = (url: string = window.location.pathname): string | null => {
  const match = url.match(URL_REGEXP);

  if (!match) {
    return null;
  }

  return PLAYBACKS.LIST.name;
};
